<div class="px-4 mt-24">
  <div class="max-w-md w-full mx-auto">
    <!-- Header -->
    <div class="text-center mb-8">
      <h1 class="text-4xl font-bold text-base-content">Verify Your Account</h1>
      <p class="text-base-content/70 mt-2">
        Complete the verification process to access your account
      </p>
    </div>

    <!-- Card -->
    <div class="daisy-card bg-base-100 shadow-xl">
      <div class="daisy-card-body">
        <p class="text-base-content/70 text-center mb-6">
          We are sending an OTP to validate your mobile number or email address
        </p>

        <!-- Resend Timer/Button -->
        <div class="text-center mb-4">
          @if (resendEnable) {
          <button (click)="sendCode()" class="daisy-btn daisy-btn-outline">
            Resend Code
          </button>
          } @else {
          <p class="text-base-content/70">
            Resend available in
            {{ timeRemaining$ | async | date: 'mm:ss':'UTC' }}
          </p>
          }
        </div>

        <!-- Error Alert -->
        @if (otpError) {
        <div class="daisy-alert daisy-alert-error mb-4">
          <i class="fa-solid fa-circle-exclamation"></i>
          <span>{{ otpError }}</span>
        </div>
        }

        <!-- OTP Form -->
        <form class="space-y-6" [formGroup]="otpForm">
          <div class="daisy-form-control w-full flex items-center justify-center">
            <black-otp formControlName="otp"></black-otp>
          </div>

          <!-- Submit Button -->
          <button
            [disabled]="otpLength < 6"
            (click)="submit()"
            class="daisy-btn daisy-btn-primary w-full"
          >
            Verify
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
